const modalSelector = ".disclamer__modal";
const agreeSelector = ".disclamer__modal-btn--agree";
const disagreeSelector = ".disclamer__modal-btn--disagree";
const closeSelector = ".disclamer__modal-close";
const storageKey = "abraham.disclaimerAccepted";
const minimumDelay = 5000;
const maximumDelay = 10000;

let initialized = false;

export function initDisclaimerModal() {
  if (initialized) return;

  const modal = document.querySelector(modalSelector);

  if (!modal || hasAcceptedDisclaimer()) return;

  initialized = true;
  bindDisclaimerActions(modal);

  setTimeout(function() {
    if (!hasAcceptedDisclaimer()) {
      openModal(modal);
    }
  }, getRandomDelay());
}

function bindDisclaimerActions(modal) {
  modal.querySelectorAll(agreeSelector).forEach(function(button) {
    button.addEventListener("click", function(event) {
      event.preventDefault();
      acceptDisclaimer();
      closeModal(modal);
    });
  });

  modal.querySelectorAll(disagreeSelector + ", " + closeSelector).forEach(function(button) {
    button.addEventListener("click", function(event) {
      event.preventDefault();
      closeModal(modal);
    });
  });
}

function openModal(modal) {
  modal.classList.add("open");
  modal.setAttribute("aria-hidden", "false");
}

function closeModal(modal) {
  modal.classList.remove("open");
  modal.setAttribute("aria-hidden", "true");
}

function acceptDisclaimer() {
  try {
    window.localStorage.setItem(storageKey, "true");
  } catch (error) {
    return;
  }
}

function hasAcceptedDisclaimer() {
  try {
    return window.localStorage.getItem(storageKey) === "true";
  } catch (error) {
    return false;
  }
}

function getRandomDelay() {
  return Math.floor(Math.random() * (maximumDelay - minimumDelay + 1)) + minimumDelay;
}
